var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "window",
      attrs: { id: "connect", role: "tabpanel", "aria-label": "Connect" },
    },
    [
      _c("div", { staticClass: "header" }, [_c("SidebarToggle")], 1),
      _c(
        "form",
        {
          staticClass: "container",
          attrs: { method: "post", action: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c("marquee", { staticClass: "blink" }, [
            _c(
              "span",
              {
                staticStyle: {
                  color: "white",
                  "font-weight": "bold",
                  "text-decoration": "white",
                },
              },
              [
                _vm._v(
                  "INFO: Shkruaje Emrin qe do te futesh ne Chat dhe tani kliko LIDHU NE CHAT apo KiwiIRC"
                ),
              ]
            ),
          ]),
          !_vm.config.lockNetwork
            ? [
                _c("h2", [_vm._v("Network settings")]),
                _c("div", { staticClass: "connect-row" }, [
                  _c("label", { attrs: { for: "connect:name" } }, [
                    _vm._v("Name"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.defaults.name,
                        expression: "defaults.name",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      id: "connect:name",
                      name: "name",
                      maxlength: "100",
                    },
                    domProps: { value: _vm.defaults.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.defaults, "name", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "connect-row" }, [
                  _c("label", { attrs: { for: "connect:host" } }, [
                    _vm._v("Server"),
                  ]),
                  _c("div", { staticClass: "input-wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.defaults.host,
                          expression: "defaults.host",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        id: "connect:host",
                        name: "host",
                        "aria-label": "Server address",
                        maxlength: "255",
                        required: "",
                      },
                      domProps: { value: _vm.defaults.host },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.defaults, "host", $event.target.value)
                        },
                      },
                    }),
                    _c("span", { attrs: { id: "connect:portseparator" } }, [
                      _vm._v(":"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.defaults.port,
                          expression: "defaults.port",
                        },
                      ],
                      staticClass: "input",
                      attrs: {
                        id: "connect:port",
                        type: "number",
                        min: "1",
                        max: "65535",
                        name: "port",
                        "aria-label": "Server port",
                      },
                      domProps: { value: _vm.defaults.port },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.defaults, "port", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "connect-row" },
                  [
                    _c("label", { attrs: { for: "connect:password" } }, [
                      _vm._v("Password"),
                    ]),
                    _c("RevealPassword", {
                      staticClass: "input-wrap password-container",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (slotProps) {
                              return [
                                (slotProps.isVisible ? "text" : "password") ===
                                "checkbox"
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.defaults.password,
                                          expression: "defaults.password",
                                        },
                                      ],
                                      staticClass: "input",
                                      attrs: {
                                        id: "connect:password",
                                        placeholder:
                                          "Server password (optional)",
                                        name: "password",
                                        maxlength: "300",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.defaults.password
                                        )
                                          ? _vm._i(
                                              _vm.defaults.password,
                                              null
                                            ) > -1
                                          : _vm.defaults.password,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.defaults.password,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.defaults,
                                                  "password",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.defaults,
                                                  "password",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.defaults,
                                              "password",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    })
                                  : (slotProps.isVisible
                                      ? "text"
                                      : "password") === "radio"
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.defaults.password,
                                          expression: "defaults.password",
                                        },
                                      ],
                                      staticClass: "input",
                                      attrs: {
                                        id: "connect:password",
                                        placeholder:
                                          "Server password (optional)",
                                        name: "password",
                                        maxlength: "300",
                                        type: "radio",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.defaults.password,
                                          null
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.defaults,
                                            "password",
                                            null
                                          )
                                        },
                                      },
                                    })
                                  : _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.defaults.password,
                                          expression: "defaults.password",
                                        },
                                      ],
                                      staticClass: "input",
                                      attrs: {
                                        id: "connect:password",
                                        placeholder:
                                          "Server password (optional)",
                                        name: "password",
                                        maxlength: "300",
                                        type: slotProps.isVisible
                                          ? "text"
                                          : "password",
                                      },
                                      domProps: {
                                        value: _vm.defaults.password,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.defaults,
                                            "password",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2649577346
                      ),
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "connect-row" }, [
                  _c("label"),
                  _c("div", { staticClass: "input-wrap" }, [
                    _c("label", { staticClass: "tls" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.defaults.tls,
                            expression: "defaults.tls",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "tls",
                          disabled: _vm.defaults.hasSTSPolicy,
                        },
                        domProps: {
                          checked: Array.isArray(_vm.defaults.tls)
                            ? _vm._i(_vm.defaults.tls, null) > -1
                            : _vm.defaults.tls,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.defaults.tls,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.defaults,
                                    "tls",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.defaults,
                                    "tls",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.defaults, "tls", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n\t\t\t\t\t\t\tUse secure connection (TLS)\n\t\t\t\t\t\t\t"
                      ),
                      _vm.defaults.hasSTSPolicy
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "tooltipped tooltipped-n tooltipped-no-delay",
                              attrs: {
                                "aria-label":
                                  "This network has a strict transport security policy, you will be unable to disable TLS",
                              },
                            },
                            [_vm._v("🔒 STS")]
                          )
                        : _vm._e(),
                    ]),
                    _c("label", { staticClass: "tls" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.defaults.rejectUnauthorized,
                            expression: "defaults.rejectUnauthorized",
                          },
                        ],
                        attrs: { type: "checkbox", name: "rejectUnauthorized" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.defaults.rejectUnauthorized
                          )
                            ? _vm._i(_vm.defaults.rejectUnauthorized, null) > -1
                            : _vm.defaults.rejectUnauthorized,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.defaults.rejectUnauthorized,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.defaults,
                                    "rejectUnauthorized",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.defaults,
                                    "rejectUnauthorized",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.defaults, "rejectUnauthorized", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n\t\t\t\t\t\t\tOnly allow trusted certificates\n\t\t\t\t\t\t"
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm.config.lockNetwork &&
              !_vm.$store.state.serverConfiguration.public
            ? [
                _c("h2", [_vm._v("Network settings")]),
                _c("div", { staticClass: "connect-row" }, [
                  _c("label", { attrs: { for: "connect:name" } }, [
                    _vm._v("Name"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.defaults.name,
                        expression: "defaults.name",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      id: "connect:name",
                      name: "name",
                      maxlength: "100",
                    },
                    domProps: { value: _vm.defaults.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.defaults, "name", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "connect-row" },
                  [
                    _c("label", { attrs: { for: "connect:password" } }, [
                      _vm._v("Password"),
                    ]),
                    _c("RevealPassword", {
                      staticClass: "input-wrap password-container",
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (slotProps) {
                            return [
                              (slotProps.isVisible ? "text" : "password") ===
                              "checkbox"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.defaults.password,
                                        expression: "defaults.password",
                                      },
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      id: "connect:password",
                                      placeholder: "Server password (optional)",
                                      name: "password",
                                      maxlength: "300",
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.defaults.password
                                      )
                                        ? _vm._i(_vm.defaults.password, null) >
                                          -1
                                        : _vm.defaults.password,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.defaults.password,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.defaults,
                                                "password",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.defaults,
                                                "password",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.defaults,
                                            "password",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  })
                                : (slotProps.isVisible
                                    ? "text"
                                    : "password") === "radio"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.defaults.password,
                                        expression: "defaults.password",
                                      },
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      id: "connect:password",
                                      placeholder: "Server password (optional)",
                                      name: "password",
                                      maxlength: "300",
                                      type: "radio",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.defaults.password,
                                        null
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.defaults,
                                          "password",
                                          null
                                        )
                                      },
                                    },
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.defaults.password,
                                        expression: "defaults.password",
                                      },
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      id: "connect:password",
                                      placeholder: "Server password (optional)",
                                      name: "password",
                                      maxlength: "300",
                                      type: slotProps.isVisible
                                        ? "text"
                                        : "password",
                                    },
                                    domProps: { value: _vm.defaults.password },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.defaults,
                                          "password",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _c("h2", [
            _vm._v("Dergo foto dhe video permes chat njesoj si ne Whatsapp!"),
          ]),
          _c("div", { staticClass: "connect-row" }, [
            _c("label", { attrs: { for: "connect:nick" } }, [
              _vm._v("Nofka juaj:"),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.defaults.nick,
                  expression: "defaults.nick",
                },
              ],
              staticClass: "input nick",
              attrs: {
                id: "connect:nick",
                name: "nick",
                pattern: "[^\\s:!@]+",
                maxlength: "100",
                required: "",
              },
              domProps: { value: _vm.defaults.nick },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.defaults, "nick", $event.target.value)
                  },
                  _vm.onNickChanged,
                ],
              },
            }),
          ]),
          !_vm.config.useHexIp
            ? [
                _c("div", { staticClass: "connect-row" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.defaults.username,
                        expression: "defaults.username",
                      },
                    ],
                    ref: "usernameInput",
                    staticClass: "input username",
                    attrs: {
                      type: "hidden",
                      id: "connect:username",
                      name: "username",
                      maxlength: "100",
                      display: "none",
                    },
                    domProps: { value: _vm.defaults.username },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.defaults, "username", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            : _vm._e(),
          _c("div", { staticClass: "connect-row" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.defaults.realname,
                  expression: "defaults.realname",
                },
              ],
              staticClass: "input",
              attrs: {
                type: "hidden",
                id: "connect:realname",
                name: "realname",
                maxlength: "300",
                display: "none",
              },
              domProps: { value: _vm.defaults.realname },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.defaults, "realname", $event.target.value)
                },
              },
            }),
          ]),
          _vm.defaults.uuid && !_vm.$store.state.serverConfiguration.public
            ? [
                _c("div", { staticClass: "connect-row" }, [
                  _vm._m(0),
                  _c("textarea", {
                    ref: "commandsInput",
                    staticClass: "input",
                    attrs: { id: "connect:commands", name: "commands" },
                    domProps: {
                      value: _vm.defaults.commands
                        ? _vm.defaults.commands.join("\n")
                        : "",
                    },
                    on: { input: _vm.resizeCommandsInput },
                  }),
                ]),
              ]
            : !_vm.defaults.uuid
            ? [
                _c("div", { staticClass: "connect-row" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.defaults.join,
                        expression: "defaults.join",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "hidden",
                      id: "connect:channels",
                      name: "join",
                      display: "none",
                    },
                    domProps: { value: _vm.defaults.join },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.defaults, "join", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            : _vm._e(),
          _vm.$store.state.serverConfiguration.public
            ? [
                _vm.config.lockNetwork
                  ? [
                      _c("div", { staticClass: "connect-row" }, [
                        _c("label"),
                        _c("div", { staticClass: "input-wrap" }, [
                          _c("label", { staticClass: "tls" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.displayPasswordField,
                                  expression: "displayPasswordField",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.displayPasswordField)
                                  ? _vm._i(_vm.displayPasswordField, null) > -1
                                  : _vm.displayPasswordField,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.displayPasswordField,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.displayPasswordField = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.displayPasswordField = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.displayPasswordField = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tJam i regjistruar\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                        ]),
                      ]),
                      _vm.displayPasswordField
                        ? _c(
                            "div",
                            { staticClass: "connect-row" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "connect:password" } },
                                [_vm._v("Fjalkalimi:")]
                              ),
                              _c("RevealPassword", {
                                staticClass: "input-wrap password-container",
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (slotProps) {
                                        return [
                                          (slotProps.isVisible
                                            ? "text"
                                            : "password") === "checkbox"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.defaults.password,
                                                    expression:
                                                      "defaults.password",
                                                  },
                                                ],
                                                ref: "publicPassword",
                                                staticClass: "input",
                                                attrs: {
                                                  id: "connect:password",
                                                  placeholder:
                                                    "Shkruaj fjalekalimin ketu!",
                                                  name: "password",
                                                  maxlength: "300",
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.defaults.password
                                                  )
                                                    ? _vm._i(
                                                        _vm.defaults.password,
                                                        null
                                                      ) > -1
                                                    : _vm.defaults.password,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.defaults.password,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.defaults,
                                                            "password",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.defaults,
                                                            "password",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.defaults,
                                                        "password",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                },
                                              })
                                            : (slotProps.isVisible
                                                ? "text"
                                                : "password") === "radio"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.defaults.password,
                                                    expression:
                                                      "defaults.password",
                                                  },
                                                ],
                                                ref: "publicPassword",
                                                staticClass: "input",
                                                attrs: {
                                                  id: "connect:password",
                                                  placeholder:
                                                    "Shkruaj fjalekalimin ketu!",
                                                  name: "password",
                                                  maxlength: "300",
                                                  type: "radio",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.defaults.password,
                                                    null
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$set(
                                                      _vm.defaults,
                                                      "password",
                                                      null
                                                    )
                                                  },
                                                },
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.defaults.password,
                                                    expression:
                                                      "defaults.password",
                                                  },
                                                ],
                                                ref: "publicPassword",
                                                staticClass: "input",
                                                attrs: {
                                                  id: "connect:password",
                                                  placeholder:
                                                    "Shkruaj fjalekalimin ketu!",
                                                  name: "password",
                                                  maxlength: "300",
                                                  type: slotProps.isVisible
                                                    ? "text"
                                                    : "password",
                                                },
                                                domProps: {
                                                  value: _vm.defaults.password,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.defaults,
                                                      "password",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1437501757
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ]
            : [
                _c("h2", { attrs: { id: "label-auth" } }, [
                  _vm._v("Authentication"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "connect-row connect-auth",
                    attrs: { role: "group", "aria-labelledby": "label-auth" },
                  },
                  [
                    _c("label", { staticClass: "opt" }, [
                      _c("input", {
                        attrs: { type: "radio", name: "sasl", value: "" },
                        domProps: { checked: !_vm.defaults.sasl },
                        on: {
                          change: function ($event) {
                            return _vm.setSaslAuth("")
                          },
                        },
                      }),
                      _vm._v("\n\t\t\t\t\t\tNo authentication\n\t\t\t\t\t"),
                    ]),
                    _c("label", { staticClass: "opt" }, [
                      _c("input", {
                        attrs: { type: "radio", name: "sasl", value: "plain" },
                        domProps: { checked: _vm.defaults.sasl === "plain" },
                        on: {
                          change: function ($event) {
                            return _vm.setSaslAuth("plain")
                          },
                        },
                      }),
                      _vm._v(
                        "\n\t\t\t\t\t\tUsername + password (SASL PLAIN)\n\t\t\t\t\t"
                      ),
                    ]),
                    !_vm.$store.state.serverConfiguration.public &&
                    _vm.defaults.tls
                      ? _c("label", { staticClass: "opt" }, [
                          _c("input", {
                            attrs: {
                              type: "radio",
                              name: "sasl",
                              value: "external",
                            },
                            domProps: {
                              checked: _vm.defaults.sasl === "external",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.setSaslAuth("external")
                              },
                            },
                          }),
                          _vm._v(
                            "\n\t\t\t\t\t\tClient certificate (SASL EXTERNAL)\n\t\t\t\t\t"
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm.defaults.sasl === "plain"
                  ? [
                      _c("div", { staticClass: "connect-row" }, [
                        _c("label", { attrs: { for: "connect:username" } }, [
                          _vm._v("Account"),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.defaults.saslAccount,
                              expression: "defaults.saslAccount",
                            },
                          ],
                          staticClass: "input",
                          attrs: {
                            id: "connect:saslAccount",
                            name: "saslAccount",
                            maxlength: "100",
                            required: "",
                          },
                          domProps: { value: _vm.defaults.saslAccount },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.defaults,
                                "saslAccount",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "connect-row" },
                        [
                          _c("label", { attrs: { for: "connect:password" } }, [
                            _vm._v("Password"),
                          ]),
                          _c("RevealPassword", {
                            staticClass: "input-wrap password-container",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (slotProps) {
                                    return [
                                      (slotProps.isVisible
                                        ? "text"
                                        : "password") === "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.defaults.saslPassword,
                                                expression:
                                                  "defaults.saslPassword",
                                              },
                                            ],
                                            staticClass: "input",
                                            attrs: {
                                              id: "connect:saslPassword",
                                              name: "saslPassword",
                                              maxlength: "300",
                                              required: "",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.defaults.saslPassword
                                              )
                                                ? _vm._i(
                                                    _vm.defaults.saslPassword,
                                                    null
                                                  ) > -1
                                                : _vm.defaults.saslPassword,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.defaults.saslPassword,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.defaults,
                                                        "saslPassword",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.defaults,
                                                        "saslPassword",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.defaults,
                                                    "saslPassword",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          })
                                        : (slotProps.isVisible
                                            ? "text"
                                            : "password") === "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.defaults.saslPassword,
                                                expression:
                                                  "defaults.saslPassword",
                                              },
                                            ],
                                            staticClass: "input",
                                            attrs: {
                                              id: "connect:saslPassword",
                                              name: "saslPassword",
                                              maxlength: "300",
                                              required: "",
                                              type: "radio",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.defaults.saslPassword,
                                                null
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.defaults,
                                                  "saslPassword",
                                                  null
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.defaults.saslPassword,
                                                expression:
                                                  "defaults.saslPassword",
                                              },
                                            ],
                                            staticClass: "input",
                                            attrs: {
                                              id: "connect:saslPassword",
                                              name: "saslPassword",
                                              maxlength: "300",
                                              required: "",
                                              type: slotProps.isVisible
                                                ? "text"
                                                : "password",
                                            },
                                            domProps: {
                                              value: _vm.defaults.saslPassword,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.defaults,
                                                  "saslPassword",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3144405648
                            ),
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm.defaults.sasl === "external"
                  ? _c("div", { staticClass: "connect-sasl-external" }, [
                      _c("p", [
                        _vm._v(
                          "\n\t\t\t\t\t\tThe Lounge automatically generates and manages the client certificate.\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "\n\t\t\t\t\t\tOn the IRC server, you will need to tell the services to attach the\n\t\t\t\t\t\tcertificate fingerprint (certfp) to your account, for example:\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._m(1),
                    ])
                  : _vm._e(),
              ],
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: {
                  type: "submit",
                  disabled: _vm.disabled ? true : false,
                },
              },
              [
                _vm.defaults.uuid
                  ? [_vm._v("Save network")]
                  : [_vm._v("Lidhu me Chat")],
              ],
              2
            ),
          ]),
          _c("h2", [_vm._v("Chat Alternativ nese keni probleme!")]),
          _c(
            "a",
            { staticClass: "btn", attrs: { href: "https://chat.chatohu.net" } },
            [_c("center", [_vm._v("KiwiIRC")])],
            1
          ),
          _c("br"),
          _c("br"),
          _vm._m(2),
          _c("br"),
          _c("table", { attrs: { id: "customers" } }, [
            _vm._m(3),
            _c("tr", [
              _c("td", [
                _c(
                  "span",
                  { staticStyle: { color: "black", "font-weight": "bold" } },
                  [
                    _vm._v(
                      "Nuk e keni te regjistruar Nick/Nofken tuaj akoma? nese deshironi qe te mos ju keqperdoret Nofka/Nicku juaj nga te tjeret atehere vazhdoni me "
                    ),
                    _c(
                      "a",
                      { attrs: { href: "https://login.chatohu.com/register" } },
                      [
                        _c("center", [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold",
                              },
                            },
                            [_vm._v("Regjistrimin duke klikuar ketu!")]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _c("br"),
          _vm._m(4),
          _c("br"),
          _vm._m(5),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "connect:commands" } }, [
      _vm._v("\n\t\t\t\t\t\tCommands\n\t\t\t\t\t\t"),
      _c(
        "span",
        {
          staticClass: "tooltipped tooltipped-ne tooltipped-no-delay",
          attrs: {
            "aria-label":
              "One /command per line.\nEach command will be executed in\nthe server tab on new connection",
          },
        },
        [_c("button", { staticClass: "extra-help" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", [_c("code", [_vm._v("/msg NickServ CERT ADD")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { attrs: { id: "customers" } }, [
      _c("tr", [
        _c("th", [_vm._v("Thelounge")]),
        _c("th", [_vm._v("KiwiIRC")]),
      ]),
      _c("tr", [
        _c("td", [
          _c(
            "span",
            { staticStyle: { color: "black", "font-weight": "italic" } },
            [
              _vm._v("Mund te dergoni "),
              _c(
                "span",
                { staticStyle: { color: "black", "font-weight": "bold" } },
                [_vm._v("Foto/Video")]
              ),
              _vm._v(" permes Chat"),
            ]
          ),
        ]),
        _c("td", [
          _c(
            "span",
            { staticStyle: { color: "black", "font-weight": "italic" } },
            [
              _vm._v("Thirrje permes "),
              _c(
                "span",
                { staticStyle: { color: "black", "font-weight": "bold" } },
                [_vm._v("Video/Call")]
              ),
              _vm._v(" dhe dergo "),
              _c(
                "span",
                { staticStyle: { color: "black", "font-weight": "bold" } },
                [_vm._v("Foto/Video/Voice permes chat")]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("th", [_vm._v("Regjistroni Nick/Nofeken tuaj!")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { attrs: { id: "customers" } }, [
      _c("tr", [_c("th", [_vm._v("Probleme me chatin!")])]),
      _c("tr", [
        _c("td", [
          _c(
            "span",
            { staticStyle: { color: "black", "font-weight": "bold" } },
            [
              _vm._v(
                "Per me shum info ose keni probleme me chatin , G-line / Z-line / AKill apo keni probleme me dike tjeter ne CHAT, na shkruani ne "
              ),
              _c(
                "span",
                { staticStyle: { color: "red", "font-weight": "bold" } },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "mailto:admiral@lidhu.org?subject=Probleme me Chatin",
                      },
                    },
                    [_vm._v("admiral@lidhu.org")]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { attrs: { id: "customers" } }, [
      _c("tr", [_c("th", [_vm._v("Informacione shtese!")])]),
      _c("tr", [
        _c("td", [
          _c(
            "span",
            { staticStyle: { color: "black", "font-weight": "italic" } },
            [
              _vm._v(
                "Rregullorja Chatit: Ne publik perdorni vetem Gjuhen Shqipe, bisedat Private mos i nxjerrni ne Publik, Ndalohet perdorimi i Nick-ave te pakuptimte dhe provokues, Ndalohet perdorimi i Proxy/VPN, Ndalohen sulmet ndaj Chatit si Clone/Flood, Ndalohet rrepsisht Reklamimi i Facebook/Instagram/Skype/SnapChat/Twitter apo cfardo lloj linku, Ndalohet  te shkruani me shkronja te MEDHA dhe te perseritni fjalin me shume se 2here, Ndalohen rrepsisht Kercenimet, diskriminim, racizem, sharje dhe ofendime ndaj stafit, chatit ose chatuesve tjere."
              ),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }